export { default } from './makeStyles';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/esm/makeStyles/index.js
// module id = 424
// module chunks = 2